import { MutableRefObject } from 'react';
import * as PIXI from "pixi.js"

import * as FBRConstants from '../FBRConstants';
import * as FBRTypes from '../FBRTypes';


const textStyle1 = new PIXI.TextStyle({
    align: "center",
    dropShadow: true,
    dropShadowAlpha: 0.5,
    dropShadowAngle: 0.95,
    dropShadowBlur: 7,
    dropShadowDistance: 11,
    fill: [
        "#f6f5f4",
        "#613583"
    ],
    fillGradientStops: [
        0.1,
        1
    ],
		fontFamily: 'Quantico', 
    fontSize: 49,
    lineJoin: "round",
    padding: 25,
    strokeThickness: 9
});

function createStreakIndicator(textLabel: string) {
	return ( function () {
	const streakText = new PIXI.Text(
		textLabel, 
		textStyle1
	);
	streakText.anchor.set(0.5, 0.5);
	streakText.visible = false;
	let lastVisibilityChangeTime = Date.now();
	const lifetimeDuration = 2000;

	let _selfUpdaterTimeout:number|null = null;

	const _startSelfUpdater =  () => {
		if(_selfUpdaterTimeout == null) {
			//console.log('starting self updater');
			_selfUpdaterTimeout = window.setInterval( () => {
				if(streakText.visible) {
					//console.log('updating!');
					_update();
				} else {
					if(_selfUpdaterTimeout != null) {
						//console.log('clearing self updater');
						clearInterval(_selfUpdaterTimeout);
						_selfUpdaterTimeout = null;
					}
				}
			}, 5);
		}
	}
	
	const _update = () => {
		if(streakText.visible) {
			streakText.y -= 1;
			const now = Date.now();
			const curProgress = (lifetimeDuration-((lastVisibilityChangeTime+lifetimeDuration)-now))/lifetimeDuration;
			const opacity = Math.cos((curProgress * Math.PI)/2);
			streakText.alpha = opacity;
			if(now > lastVisibilityChangeTime+lifetimeDuration) {
				//console.log('hide streak indicator');
				streakText.y = 0;
				streakText.visible = false;
			}
		}
	}

	const _show = () => {
		//console.log('show streak indicator');
		streakText.y = 0;
		streakText.visible = true;
		lastVisibilityChangeTime = Date.now();
		_startSelfUpdater();
	}
	return {
		text: streakText,
		update: _update,
		show: _show,
	}
	})();
}

const streakProgression:{[key:string]:any} = {
	'10': {
		bonus: 10,
		indicator: createStreakIndicator('10 in a row, nice!\n+10')
	},
	'25': {
		bonus: 25,
		indicator: createStreakIndicator('25 in a row, nice!\n+25')
	},
	'50': {
		bonus: 50,
		indicator: createStreakIndicator('50 in a row, nice!\n+50')
	},
	'69': {
		bonus: 69,
		indicator: createStreakIndicator('69 in a row, nice!\n+69')
	},
	'75': {
		bonus: 75,
		indicator: createStreakIndicator('75 in a row, nice!\n+75')
	},
	'100': {
		bonus: 100,
		indicator: createStreakIndicator('100 in a row, nice!\n+100')
	},
	'150': {
		bonus: 150,
		indicator: createStreakIndicator('150 in a row, nice!\n+150')
	},
	'200': {
		bonus: 200,
		indicator: createStreakIndicator('200 in a row, nice!\n+200')
	},
	'300': {
		bonus: 300,
		indicator: createStreakIndicator('300 in a row, nice!\n+300')
	},
	'400': {
		bonus: 400,
		indicator: createStreakIndicator('400 in a row, nice!\n+400')
	},
	'420': {
		bonus: 420,
		indicator: createStreakIndicator('420 in a row, nice!\n+420')
	},
	'500': {
		bonus: 500,
		indicator: createStreakIndicator('500 in a row, nice!\n+500')
	},
	'1000': {
		bonus: 1000,
		indicator: createStreakIndicator('1000 in a row, nice!\n+1000')
	},
};

const createStreakStatusContainer = (
	pixiAppRef: MutableRefObject<PIXI.Application | undefined>,
	globalState: MutableRefObject<FBRTypes.GlobalState>,
	incrementScore: FBRTypes.IncrementScoreFunction,
) => {
	const mainContainer = new PIXI.Container();
	const centerContainer = new PIXI.Container();
	centerContainer.x = FBRConstants.STAGE_WIDTH/2;
	centerContainer.y = FBRConstants.STAGE_HEIGHT/2;
	mainContainer.addChild(centerContainer);	
	
	Object.keys(streakProgression).forEach( (key) => {
		centerContainer.addChild(streakProgression[key].indicator.text);
	});

	//let activeStreakIndicatorKey: string|null = null;
	const _update = (() => {
		return () => {
			const currentTotalActions = globalState.current.totalCorrectActions + globalState.current.totalIncorrectActions;
			//console.log(`${globalState.current.maxSequentialCorrectActions} - ${maxSequentialActionsAtLastUpdate} = ${globalState.current.maxSequentialCorrectActions - maxSequentialActionsAtLastUpdate}`);
			if(!(currentTotalActions > globalState.current.streakTotalActionsAtLastUpdate)) {
				return;
			}
			globalState.current.streakTotalActionsAtLastUpdate = currentTotalActions;
			const maxSequentialCorrectActions = globalState.current.maxSequentialCorrectActions;
			if(
				maxSequentialCorrectActions >= 10 
				&& (
					maxSequentialCorrectActions % 5 == 0
					|| maxSequentialCorrectActions == 69
				)
			) {
				const mscaString = maxSequentialCorrectActions.toString();
				if(streakProgression[mscaString] != null) {
					incrementScore(
						streakProgression[mscaString].bonus,
						globalState
					);
					streakProgression[mscaString].indicator.show();
				}
			}
		}
	})();
	
	return {
		container: mainContainer,
		update: _update,
	};
};

export default createStreakStatusContainer;
